import { FormStyle, getLocaleDayNames, NgClass, TranslationWidth } from '@angular/common';
import { Component, Inject, Input, LOCALE_ID, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { UserService } from 'app/Shared/Services/user.service';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { CompReviewServiceService } from '../comp-review-service.service';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { HttpErrorResponse } from '@angular/common/http';
import { Select } from 'primeng/select';
import { Checkbox } from 'primeng/checkbox';
import { SelectButton } from 'primeng/selectbutton';
import {default as GridColumnsJSON} from 'app/Shared/Constant/Grid Column Names/Comp-Review-Schedule-Columns.json';
import { GridService } from 'app/Shared/Services/grid.service';
import { LowerCasePipe, CommonModule } from '@angular/common';
import { Table, TableModule } from 'primeng/table';
import { DatePickerModule } from 'primeng/datepicker';

@Component({
  selector: 'app-comp-review-schedule-report',
  standalone: true,
  imports: [MatTooltipModule, Select, ButtonModule, MultiSelectModule, MatChipsModule,
    MatIconModule, NgClass, DatePickerModule, FormsModule,
    MatDatepickerModule, MatNativeDateModule, ReactiveFormsModule,
    DialogModule, Checkbox,SelectButton,LowerCasePipe,CommonModule,TableModule],
  templateUrl: './comp-review-schedule-report.component.html',
  styleUrl: './comp-review-schedule-report.component.scss'
})
export class CompReviewScheduleReportComponent {
  filterHeader: any = "Custom Sample Scheduled Report";
  isOpenDialog: boolean = false;
  isSaving: boolean = false;
  isLoadingRecords : boolean = false;
  dayNames: readonly string[]=[];
  Monthly="M";
  Weekly="W"
  frequencyDropdownvalue: any = [];
  selectedFrequency: any = "";
  weekOfMonthDropdownvalue: any = [];
  selectedWeekOfMonth: any = "";
  dayOfWeekDropdownvalue: any = [];
  selectedDayOfWeek: any = "";
  dataset1: any[] = [];
  cols: any = [];
  GridColumns: any = GridColumnsJSON;
  columnJson: any = [];
  tbldatamsg : any = "";
  updatedUser : any = "";
  updatedDate : any = "";
  @ViewChild(('dt')) dt!: Table;

  @Input('sampleListData') sampleListData: any = [];
  selectedSamples: string[] = [];

  scheduleReportDetails:any;


  constructor(
    private readonly sharedHttpClientService: SharedHttpClientService,
    public urlService: UrlsService,
    private readonly messageService: MessageService,
    private readonly constantService: ConstantService,
    public readonly userService: UserService,
    private gridService: GridService,
    public readonly compReviewServiceService: CompReviewServiceService,
    @Inject(LOCALE_ID) private locale: string) {
    this.dayNames = getLocaleDayNames(this.locale, FormStyle.Standalone, TranslationWidth.Wide);
    for(let day of this.dayNames){
      if(!"Sunday,Saturday".includes(day))
      this.dayOfWeekDropdownvalue.push({ label: day, value: day.slice(0, 3)});
    }
    this.frequencyDropdownvalue = [
    { label: "Monthly", value: this.Monthly },
    { label: "Weekly", value: this.Weekly }];
    this.weekOfMonthDropdownvalue=[
    { label: "First Week", value: "1" },
    { label: "Second Week", value: "2" },
    { label: "Third Week", value: "3" },
    { label: "Fourth Week", value: "4" },
    { label: "Fifth Week", value: "5" }];
  }

  onScheduleReportBtn(){
    this.isOpenDialog=true;
    this.getCustomSampleScheduledReport();
    this.getColumns();
  }

  closeFilterDialog() {
    this.selectedFrequency = "";
    this.selectedWeekOfMonth = "";
    this.selectedDayOfWeek = "";
    this.selectedSamples = [];
    this.isOpenDialog = false;
  }

  getCustomSampleScheduledReport(){
    this.isLoadingRecords = true;
    this.compReviewServiceService.getCustomSampleScheduledReport(this.selectedFrequency)
    .subscribe({
      next: (dataset: any) => {
        this.isLoadingRecords = false;
        if(dataset["Data"]){
        this.scheduleReportDetails = null;
        this.scheduleReportDetails = dataset["Data"][0];
        this.selectedDayOfWeek ="";
        this.selectedWeekOfMonth="";
        this.selectedSamples=[];
        if(this.scheduleReportDetails){
          this.selectedDayOfWeek = this.scheduleReportDetails['dayOfWeek'];
          this.selectedFrequency = this.scheduleReportDetails['runFrequency'];
          this.selectedWeekOfMonth = this.scheduleReportDetails['weekOfMonth'];
          this.selectedSamples = this.scheduleReportDetails['sampleNames'].toString().split(",");
          this.updatedUser = this.scheduleReportDetails['userID'];
          this.updatedDate = this.scheduleReportDetails['updateDate'];
          this.dataset1 = this.scheduleReportDetails['systemLogs'];
          this.dataset1.map(item =>{

            for(let i=0; i<this.selectedSamples.length;i++){
              if(item['process_Remark'].indexOf(this.selectedSamples[i].trim())>0){
                item['sampleName']=this.selectedSamples[i];
                item['process_Remark'] = item['process_Remark'].replaceAll('Comparative Review ', '');
              }
            }

          });
          this.sortSampleList();
          
        }
        }
      },
      error: (err: HttpErrorResponse) => {
        this.isLoadingRecords = false;
        this.messageService.add({ severity: 'error', summary: 'Schedule Report', detail: 'Report Details Failed.' });
      }
    });
  }
  sortSampleList() {
    this.sampleListData.sort((a:any, b:any) => {
      const indexA = this.selectedSamples.indexOf(a.label);
      const indexB = this.selectedSamples.indexOf(b.label);
      return indexB-indexA;
    });
  }

  save() {
     this.compReviewServiceService.confirmationService.confirm({
      message: 'Are you sure, you want to save the changes?',
      header: 'Confirmation',
      acceptLabel: 'Yes',
      acceptIcon:'pi pi-check',
      defaultFocus: 'reject',
      rejectLabel: 'No',
      rejectIcon:'pi pi-times',
      acceptButtonStyleClass: "confirm-dialog-button",
      rejectButtonStyleClass: "confirm-dialog-button",

      accept: () => {
    this.isSaving=true;
    let payload = {
      selectedFrequency:this.selectedFrequency,
      selectedWeekOfMonth : this.selectedWeekOfMonth,
      selectedDayOfWeek: this.selectedDayOfWeek,
      selectedSamples: this.selectedSamples.join()
    };
    this.userService.logUserActivity(this.filterHeader, null, {
      'Text1': 'Custom Sample Schedule Report',
      'Text2': 'User Filter Parameters: '+ [JSON.stringify(payload)]
    });
    const selectedSamples: string[] = this.selectedSamples.filter(selectedItem => 
      this.sampleListData.some((sampleItm: any) => selectedItem == sampleItm.label)); 
    this.compReviewServiceService.saveCustomSampleScheduledReport(this.selectedFrequency,
      this.selectedWeekOfMonth, this.selectedDayOfWeek, selectedSamples
    ).subscribe({
      next: (dataset: any) => {
        this.isSaving=false;
        if (dataset["status"]) {          
          this.userService.logUserActivity(this.filterHeader, null, {
            'Text1': 'Custom Sample Schedule Report Saved Sucessfully',
            'Text2': 'User Filter Parameters: ' + [JSON.stringify(payload)]
          });
          this.messageService.add({ severity: 'success', summary: 'Schedule Report', detail: 'Report Saved Successfully.' });
          this.closeFilterDialog();
        } else {
          this.userService.logUserActivity(this.filterHeader, null, {
            'Text1': 'Custom Sample Schedule Report Save Failed',
            'Text2': 'User Filter Parameters: ' + [JSON.stringify(payload)]
          });
          this.closeFilterDialog();
          this.messageService.add({ severity: 'error', summary: 'Schedule Report', detail: 'Report Save Failed.' });
        }
      },
      error: (err: HttpErrorResponse) => {
        this.closeFilterDialog();
        this.isSaving=false;
        this.messageService.add({ severity: 'error', summary: 'Schedule Report', detail: 'Report Save Failed.' });
      }
    });
  }
  });
  }
  checkDisabledSave(){
    if(this.selectedFrequency != ""){
      if(this.selectedFrequency == this.Monthly){
        return this.selectedDayOfWeek == '' || this.selectedWeekOfMonth == ''
      }else if(this.selectedFrequency == this.Weekly){
        this.selectedWeekOfMonth == '';
        return this.selectedDayOfWeek == '';
      }
      return false;
    }
    return true;
  }

  onChangeFrequency(){
    if(this.selectedFrequency==''){
      this.selectedWeekOfMonth="";
      this.selectedDayOfWeek="";
      this.selectedSamples=[];
    }
    if(this.selectedFrequency==this.Weekly || this.selectedFrequency==this.Monthly){
    this.getCustomSampleScheduledReport();
    }
  }
  
  cancel() {
    this.closeFilterDialog();
  }


  getColumns() {
    let column: any = this.GridColumns;
    this.columnJson = [];
    if (column != null || column != undefined) {
      this.columnJson = this.gridService.getGridColumns(column);
      this.cols = this.gridService.getGridColumns(column);
    }
  }


}
